import { render, staticRenderFns } from "./TogglePill.vue?vue&type=template&id=232a8284&scoped=true"
import script from "./TogglePill.vue?vue&type=script&lang=js"
export * from "./TogglePill.vue?vue&type=script&lang=js"
import style0 from "./TogglePill.vue?vue&type=style&index=0&id=232a8284&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232a8284",
  null
  
)

export default component.exports